export const getNotSelectedLanguage = (language) => language === 'NL' ? 'EN' : 'NL'